'use strict';

class RcmFatResultsFilters {
    constructor(fat) {
        this.fat = fat;

        // DOM
        this.filters = $('#fatv2-results-filters');
        this.filtersWrapper = $('#fatv2-results-filters-and-map');
        this.filterMobile = $('#fatv2-off-canvas-menu');
        this.appliedFiltersWrapper = $('#fatv2-results-appliedfilters');
        this.appliedFilters = $('.fatv2-results-appliedfilters-content');
        this.locationFieldAutocomplete = null;

        // Selectors
        this.facetTagsSelector = '.fatv2-facet-item';
        this.facetLinksSelector = '.fatv2-facet-link';
        this.applyFiltersSelector = '#fatv2-apply-filter-button';
        this.appliedFiltersTagSelector = '.fatv2-results-appliedfilters-tag';
        this.appliedFiltersClearAllSelector = '.fatv2-results-appliedfilters-clear';
        this.locationFieldSelector = '#fatv2-filters-input-location';
        this.nameFieldSelector = '#fatv2-filters-input-teachername';
        this.filterInputSelector = '.fatv2-filters-inputs-item input';
        this.filterInputClearSelector = '.fatv2-filters-inputs-item-clear';
        this.filterInputSubmitSelector = '.fatv2-filters-inputs-search';
    }

    // Set facet filters
    set(data, isFacetFilterOnDesktop) {
        this.setForDesktop(data, isFacetFilterOnDesktop);
        this.setForMobile(data);
        this.setLocationField();
    }

    // Set facet filters (desktop)
    setForDesktop(data, isFacetFilterOnDesktop) {
        var self = this;

        // Get the current active/open item (if exists)
        var activeItemSelector = '.fatv2-results-filters .is-dropdown-submenu-parent';
        var activeItemTitle = $(activeItemSelector).filter('.is-active').length > 0 ? $(activeItemSelector).filter('.is-active').children('a').text() : null;

        // Clear HTML
        this.filters.html('');

        // Location and Teacher Name
        var locationAndTeacherNameInputs = this.getLocationAndName(data);
        locationAndTeacherNameInputs.appendTo(this.filters);

        // Facets 
        var item = this.getItemWrapper(data);
        item.appendTo(this.filters);

        // Facets from Algolia response
        $.each(data.facets, function (index, value) {
            var item = self.getItem(index, value, isFacetFilterOnDesktop, activeItemTitle);
            item.appendTo(self.filters.children('.menu'));
        });

        // Button filters
        var buttonFilters = this.getButtonFilters(data);
        buttonFilters.appendTo(this.filters);

        // Foundation constructor to enable menu dropdown
        this.filters.foundation();
    }

    // Set facet filters (mobile)
    setForMobile(data) {
        var self = this;

        this.filterMobile.html('');

        // Facets 
        var item = this.getMobileItemWrapper(data);
        item.appendTo(this.filterMobile);

        // Facets from Algolia response
        $.each(data.facets, function (index, value) {
            var item = self.getItem(index, value);
            item.appendTo(self.filterMobile.children('.menu'));
        });

        // Button apply filters
        var button = this.getMobileButton(data);
        button.appendTo(this.filterMobile);

        // Foundation constructor to enable menu dropdown
        this.filterMobile.foundation();
    }

    setLocationField() {
        var self = this;

        var options = { componentRestrictions: { country: ['ca', 'us'] } };
        var input = $(this.locationFieldSelector)[0];

        this.locationFieldAutocomplete = new google.maps.places.Autocomplete(input, options);

        // Google listener <-- from RcmFatGoogle
        this.locationFieldAutocomplete.addListener('place_changed', function () {
            var place = self.locationFieldAutocomplete.getPlace();

            if (!place || !place.geometry || !place.address_components) {
                self.fat.form.geoField.data('geoCountry', null);
                self.fat.form.geoField.data('geoLat', null);
                self.fat.form.geoField.data('geoLng', null);
                self.fat.form.geoPlaceField.val('');
            } else {
                $(place.address_components).each(function (index, value) {
                    if (value.types.indexOf('country') != -1) {
                        self.fat.form.geoField.data('geoCountry', value.short_name);
                    }
                });

                self.fat.form.geoField.data('geoLat', place.geometry.location.lat());
                self.fat.form.geoField.data('geoLng', place.geometry.location.lng());
                self.fat.form.geoPlaceField.val(place.place_id);
            }
        });

        input.addEventListener('keydown', (e) => {
            if (e.which === 13) {
                e.preventDefault();
            }
        });
    }

    // Get Location and Teacher Name inputs HTML
    getLocationAndName(data) {
        var paramTeacherName = TPS.Utility.getURLParameter('fullName');
        var html =
            `<div class="fatv2-filters-inputs">
                <div class="fatv2-filters-inputs-item">
                    <label for="fatv2-filters-input-location">Location</label>
                    <input required type="text" id="fatv2-filters-input-location" name="place" value="${this.fat.form.geoField.val()}"/>
                    <button type="button" class="fatv2-filters-inputs-item-clear"><span class="fal fa-times-circle"></span><span class="sr-only">Clear</span></button>
                </div>
                <div class="fatv2-filters-inputs-item">
                    <label for="fatv2-filters-input-teachername">Teacher Name</label>
                    <input type="text" id="fatv2-filters-input-teachername" name="fullName" value="${paramTeacherName ? decodeURIComponent(paramTeacherName) : ''}"/>
                    <button type="button" class="fatv2-filters-inputs-item-clear"><span class="fal fa-times-circle"></span><span class="sr-only">Clear</span></button>
                </div>
                <button type="button" class="button fatv2-filters-inputs-search"><span class="far fa-search"></span>Search</button>
            </div>`;

        html = $(html);
        return html;
    }

    // Get button filters HTML
    getButtonFilters(data) {
        var html = `<a class="fatv2-filters-button button hide-for-xlarge" href="javascript:void(null);" data-toggle="fatv2-off-canvas">Filters</a>`;
        html = $(html);
        return html;
    }

    // Get mobile button apply filters HTML
    getMobileButton(data) {
        var html = `<div class="text-center">
            <a class="fatv2-apply-filter-button button" id="fatv2-apply-filter-button" href="javascript:void(null);">Apply</a>
        </div>`;

        html = $(html);
        return html;
    }

    // Get filter item wrapper HTML
    getItemWrapper(data) {
        var html = `<ul class="dropdown menu no-bullet show-for-xlarge" data-dropdown-menu data-disable-hover="true" data-click-open="true" data-close-on-click-inside="false"></ul>`;
        html = $(html);
        return html;
    }

    // Get mobile filter item wrapper HTML
    getMobileItemWrapper(data) {
        var html = `<ul class="vertical menu no-bullet accordion-menu" data-accordion-menu></ul>`;
        html = $(html);
        return html;
    }

    // Get filter item HTML
    getItem(label, data, isFacetFilterOnDesktop, activeItemTitle) {
        var self = this;

        // Is the item/menu open?
        var isMenuOpen = isFacetFilterOnDesktop && activeItemTitle == this.fat._helperGetFacetLabelTranslation(label);

        // Has the item active facets?
        var hasActiveFacets = false;
        var activeFacetsCount = 0;

        // Item
        var html = `<li class="${isMenuOpen ? 'is-active' : ''}" ${isMenuOpen ? 'data-is-click="true"' : ''}>
            <a href="javascript:void(null);" data-count="">${this.fat._helperGetFacetLabelTranslation(label)}</a>
            <ul class="menu no-bullet ${isMenuOpen ? 'js-dropdown-active' : ''}"></ul>
        </li>`;

        html = $(html);

        // Values
        var el = html.find('.menu');
        $.each(data, function (index, value) {
            var html = self._helperGetValueItem(label, data, index, value);
            html.appendTo(el);

            if (self.fat.algolia.isFacetSelected(label, index)) {
                hasActiveFacets = true;
                activeFacetsCount++;
            }
        });

        // Has the item active facets?
        if (hasActiveFacets) {
            html.addClass('is-filtered');
            html.find('a[data-count]').attr('data-count', activeFacetsCount);
        }

        return html;
    }

    // Get value item
    _helperGetValueItem(label, data, index, value) {
        // value == counter
        var html = `<li class="fatv2-facet-item fatv2-facet-item--${label} ${this.fat.algolia.isFacetSelected(label, index) ? 'active' : ''}">
            <a href="javascript:void(null);" class="fatv2-facet-link" data-facet="${label}" data-facet-value="${index}">${index}</a>
        </li>`;

        html = $(html);

        return html;
    }

    setAppliedFilters() {
        var html = '';

        if (this.fat.algolia.searchSettings.facetFilters.length > 0) {
            this.fat.algolia.searchSettings.facetFilters.forEach(function (facet) {
                var facetVal = facet.split(':');
                html += `<button type="button" class="fatv2-results-appliedfilters-tag" data-facet="${facetVal[0]}" data-facet-value="${facetVal[1]}">${facetVal[1]}</button>`;
            });

            html += `<button type="button" class="fatv2-results-appliedfilters-clear">Clear All</button>`;
            this.appliedFiltersWrapper.removeClass('hide');
        } else {
            this.appliedFiltersWrapper.addClass('hide');
        }

        this.appliedFilters.html(html);
    }
}
